import { FormikErrors } from "formik";
import { FC } from "react";
import classNames from "classnames";
import { FormLabel } from "./FormLabel";
import { inputClassName } from "./FormText";
import Datepicker, { DatepickerType } from "react-tailwindcss-datepicker";

interface FormDatePickerProps extends DatepickerType {
  id: string;
  name: string;
  label?: string;
  isRequired?: boolean;
  className?: string;
  labelClassname?: string;
  containerClassname?: string;
  labelContainerClassname?: string;
  error?: string | string[] | FormikErrors<any> | FormikErrors<any>[];
}
export const FormDatePicker: FC<FormDatePickerProps> = ({
  id,
  label = "",
  isRequired,
  name,
  error,
  className,
  labelClassname,
  containerClassname,
  labelContainerClassname,
  disabled,
  ...props
}) => {
  return (
    <div className={containerClassname}>
      <FormLabel
        label={label}
        htmlFor={name}
        isRequired={isRequired}
        className={labelClassname}
        containerClassname={labelContainerClassname}
      />

      <div className="flex flex-1 flex-col relative">
        <Datepicker
          {...props}
          asSingle
          showShortcuts
          useRange={false}
          inputId={id}
          inputName={name}
          disabled={disabled}
          inputClassName={classNames(
            inputClassName,
            "!inline-block relative",
            !!error && "ring-red-500",
            disabled && "bg-gray-100 text-gray-500",
            className
          )}
          containerClassName={containerClassname}
        />

        {typeof error == "string" && !!error && (
          <span className="mt-2 text-sm text-red-500">{error}</span>
        )}
        {Array.isArray(error) && (
          <span className="mt-2 text-sm text-red-500">{error.join(", ")}</span>
        )}
      </div>
    </div>
  );
};
